import { useTranslation } from 'react-i18next';
import { useBasePath } from '~/common/hooks/useBasePath';
import { getLanguageValue, webshopConfig } from '~/config/webshopConfig';
import { getLinkRel } from '~/common/utils/urlUtil';
import { useMemo } from 'react';
import { PgArea, TgArea } from '~/common/types/area';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

export function LatestNavigation({ className }: Readonly<{ className?: string }>) {
  const { t } = useTranslation();
  const { isAgh } = useBasePath();
  const { i18n } = useTranslation();

  const links = useMemo(() => {
    return webshopConfig.latestNavigation.filter(x => !x.area || x.area === (isAgh ? PgArea : TgArea));
  }, [isAgh]);

  return (
    <div className={className} data-testid={'latest-navigation'}>
      <h2 className="block mb-4 text-xl font-bold">{t('Aktuell')}</h2>
      <nav>
        <ul className={'space-y-2'}>
          {links.map(({ titleKey, urlDe, urlFr, urlIt }) => {
            const link = getLanguageValue(i18n.language, { de: urlDe, fr: urlFr, it: urlIt });
            const title = t(titleKey as any);

            return (
              <li key={titleKey}>
                <TrackNavigationClick label={title}>
                  <a
                    href={link}
                    className="hover:text-primary"
                    target={'_blank'}
                    rel={getLinkRel(link)}
                    data-testid={`latest-navigation-${titleKey}`}
                  >
                    <h3 className={'text-base font-normal'}>{title}</h3>
                  </a>
                </TrackNavigationClick>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
